import { auth } from "apis";
import qs from 'qs';

export const sendNotifications = async (data, filter) => {
    let url = '/notifications'
    if (filter) {
        const queryString = qs.stringify(filter, { arrayFormat: 'brackets' });
        url = `/notifications?${queryString}`;
    }
    const res = await auth({
        method: "POST",
        url: url,
        data,
    });
    return res;
}

export const getNotificationHistory = async (type, page, limit, eventId) => {
    const queryParams = { type,page,limit,eventId,}
    const queryString = qs.stringify(queryParams, { arrayFormat: 'brackets', skipNulls: true });

    const res = await auth({
        method: "GET",
        url: `/notifications/history?${queryString}`,
    });

    return res;
};

export const getScheduledNotifications = async ({
    status = 'queued',
    page = 1,
    limit = 10,
    type,
} = {}) => {
    const queryParams = { status, page, limit, type };
    const queryString = qs.stringify(queryParams, { arrayFormat: 'brackets', skipNulls: true });

    const res = await auth({
        method: "GET",
        url: `/notifications/scheduled?${queryString}`,
    });

    return res;
};

export const updateScheduledNotification = async (id, data) => {
    const res = await auth({
        method: "PATCH",
        url: `/notifications/scheduled/${id}`,
        data,
    });

    return res;
};

export const cancelScheduledNotification = async (id) => {
    const res = await auth({
        method: "DELETE",
        url: `/notifications/scheduled/${id}`,
    });

    return res;
};
